module.exports = __webpack_public_path__ + "static/media/loseLarge60_1.0e828d3d.png";